import { Sort } from '@models';
import cn from 'classnames';
import { FCX } from "@datassential/platform-ui-lib";
import SortIcon from "@components/SortIcon";

const TableSortIcon: FCX<{
    isActive: boolean;
    direction: Sort;
}> = ({
    isActive,
    direction,
}) => {
    return (
        <div className={cn(
            "TableSortIcon",
            isActive && 'is-active',
        )}>
            <SortIcon
	            direction={direction}
	            className="TableSortIcon__icon"
            />
        </div>
    );
};

export default TableSortIcon;